import { AUTH_STATE_COOKIE } from '@move-auth/shared';
import getCookie from './getCookie';

export default () => {
  try {
    const authState = decodeURIComponent(getCookie(AUTH_STATE_COOKIE));

    return JSON.parse(authState);
  } catch (error) {
    /* */
  }
  return {};
};
